var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"time-range ma-1",attrs:{"color":_vm.isSelected ? 'primary' : undefined,"outlined":!_vm.isSelected},on:{"click":function($event){return _vm.$emit('select', _vm.rdv)}}},[_vm._v(" "+_vm._s(_vm.rdv.range)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }